import { Link } from 'react-router-dom';
import { Logo } from '@/components/Logo';

/** Spanish 404 — branded dark panel, cohesive with the landing and login. */
export function NotFoundPage() {
  return (
    <div className="bg-brand-gradient hero-aurora relative flex min-h-dvh flex-col items-center justify-center gap-5 overflow-hidden p-6 text-center text-brand-white">
      <Logo variant="light" className="relative h-8" />
      <p
        className="relative font-semibold leading-none tracking-tight text-glow-gold"
        style={{ fontSize: 'clamp(4rem, 12vw, 7rem)' }}
      >
        404
      </p>
      <p className="relative max-w-sm text-brand-silver">
        No encontramos la página que buscas. Es posible que el enlace haya cambiado o que ya no
        exista.
      </p>
      <div className="relative mt-2 flex flex-wrap items-center justify-center gap-3">
        <Link
          to="/"
          className="press inline-flex h-11 items-center justify-center rounded-md bg-brand-accent px-5 text-sm font-semibold text-on-accent transition-colors hover:bg-accent-hover"
        >
          Ir al inicio
        </Link>
        <Link
          to="/login"
          className="press inline-flex h-11 items-center justify-center rounded-md border border-brand-silver/30 px-5 text-sm font-semibold text-brand-white transition-colors hover:border-brand-silver/60 hover:bg-brand-white/5"
        >
          Iniciar sesión
        </Link>
      </div>
    </div>
  );
}
